<template>
  <v-layout row wrap>
    <v-flex sm12>
      <v-breadcrumbs :items="miga" divider=">" class="blue-grey lighten-5">
        <template v-slot:item="props">
          <router-link
            :to="{ path: props.item.href, params: {
              id: props.item.id,
              title: props.item.text
            }}"
            v-if="!props.item.disabled"
          >{{ props.item.text }}</router-link>
          <a
            :href="props.item.href"
            :class="[props.item.disabled && 'disabled']"
            v-else
          >{{ props.item.text }}</a>
        </template>
      </v-breadcrumbs>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      miga: "global/getMigas"
    }),
  },
  methods: {}
};
</script>


<style lang="scss">
.disabled {
  color: grey;
  pointer-events: none;
  text-decoration: none;
}

.v-breadcrumbs li:nth-child(2n) {
  padding: 0;
}

ul.v-breadcrumbs.blue-grey.lighten-5.theme--light {
  font-size: 12px;
  text-decoration: none;
  padding: 10px 0px 10px 24px;
  min-height: 41px;

  li.v-breadcrumbs__divider{
    padding: 0 0px;
    margin: 0 8px;
  }

  a{
    text-decoration: none;
    color: #78909C;
  }
}
</style>